import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../../environments/environment";
import { AddOrRemoveChildCategoryDto, CategoryV2Dto, CreateCategoryDto, CreateCategoryResponse, ListCategoryParams, ListCategoryResponse, UpdateCategoryDto } from "../../../../models/category.v2";
import { buildQueryParamsFromObject } from "../../../../util/utils";

@Injectable({
  providedIn: "root",
})
export class CategoryV2Service {
  constructor(private _http: HttpClient) {}

  list(
    storeId: string,
    p: ListCategoryParams
  ): Observable<ListCategoryResponse> {
    return this._http.get<ListCategoryResponse>(
      environment.url + `/management/category/v2/store/${storeId}`,
      { params: buildQueryParamsFromObject(p) }
    );
  }

  get(storeId: string, id: string): Observable<CategoryV2Dto> {
    const url = `${
      environment.url
    }/management/category/v2/store/${storeId}/${id}?_=${Date.now()}`;
    return this._http.get<CategoryV2Dto>(url);
  }

  create(
    storeId: string,
    body: CreateCategoryDto
  ): Observable<CreateCategoryResponse> {
    return this._http.post<CreateCategoryResponse>(
      environment.url + `/management/category/v2/store/${storeId}`,
      body
    );
  }

  update(
    storeId: string,
    categoryId: string,
    body: UpdateCategoryDto
  ): Observable<void> {
    return this._http.put<void>(
      environment.url +
        `/management/category/v2/store/${storeId}/${categoryId}`,
      body
    );
  }

  delete(storeId: string, id: string): Observable<void> {
    return this._http.delete<void>(
      environment.url + `/management/category/v2/store/${storeId}/${id}`
    );
  }
  enable(storeId: string, ids: string[]): Observable<void> {
    return this._http.put<void>(
      `${environment.url}/management/category/v2/store/${storeId}/enabled`,
      ids
    );
  }

  disable(storeId: string, ids: string[]): Observable<void> {
    return this._http.put<void>(
      `${environment.url}/management/category/v2/store/${storeId}/disabled`,
      ids
    );
  }

  addParent(
    storeId: string,
    id: string,
    body: AddOrRemoveChildCategoryDto
  ): Observable<void> {
    return this._http.patch<void>(
      environment.url +
        `/management/category/v2/store/${storeId}/${id}/children`,
      body
    );
  }

  removeParent(
    storeId: string,
    id: string,
    body: AddOrRemoveChildCategoryDto
  ): Observable<void> {
    return this._http.patch<void>(
      environment.url +
        `/management/category/v2/store/${storeId}/${id}/children`,
      body
    );
  }
}